import { TFunction } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { ActionMenuProps } from '@lyearn/molecules';
import { ALL_FIELDS } from '@/modules/corporate/modules/database/fields';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const SELECTED_ITEM_OVERRIDES = {
  endIcon: <CheckMark className="h-20 w-20 fill-current text-icon-active" />,
};

const getSubMenuItem = (t: TFunction, item: DatabaseField, columnType: DatabaseFieldTypeEnum) => {
  const { Icon, labelKey, type } = item;
  return {
    id: item.type,
    StartIcon: Icon,
    label: t(labelKey),
    ...(columnType === type && SELECTED_ITEM_OVERRIDES),
  };
};

const getSubMenuItems = (
  t: TFunction,
  columnType: DatabaseFieldTypeEnum,
): ActionMenuProps['items'] => {
  return ALL_FIELDS.map((item) => getSubMenuItem(t, item, columnType));
};

export default getSubMenuItems;
